module.exports = __webpack_public_path__ + "img/register2.6ea7ffd.png";